<template>
  <v-main>

    <v-container fluid id="title-and-cpoy">

      <div v-if="isDebug">
        【デバッグモード】
        <div v-if="!isMobileDevice()">
          <div>PCで表示</div>
        </div>
        <div v-if="isMobileDevice()">
          <div>モバイルで表示</div>
        </div>
      </div>


    <!-- 背景素材 -->
    <div class="bg-abs bg-dots-01">
        <v-img :src="dots"></v-img>
    </div>
    <div class="bg-abs bg-dots-02">
        <v-img :src="dots"></v-img>
    </div>
    <div class="bg-abs bg-dots-03">
        <v-img :src="dots"></v-img>
    </div>
    <div class="bg-abs bg-dots-04">
        <v-img :src="dots"></v-img>
    </div>
    <div class="bg-abs bg-dots-05">
        <v-img :src="dots"></v-img>
    </div>
    <div class="bg-abs bg-lines-01">
        <v-img :src="lines"></v-img>
    </div>
    <div class="bg-abs bg-lines-02">
        <v-img :src="lines"></v-img>
    </div>
    <div class="bg-abs bg-lines-03">
        <v-img :src="lines"></v-img>
    </div>
    <div class="bg-abs bg-lines-04">
        <v-img :src="lines"></v-img>
    </div>



      <!-- 新型コロナウィルス感染症対策について -->
      <DialogCovid19 />

      <!-- 大見出しh1 -->
      <v-container class="mx-auto text-block mt-10">
        <h2 v-html="$t('LP.intro.headering')" class="text-h6 font-weight-bold text-center text-pre-wrap">
        </h2>
      </v-container>



      <!-- リード文 -->

      <v-container v-if="isMobileDevice()" class="mx-auto text-body-1 font-weight-bold text-center text-block mt-8"
        style="line-height:1.8;">
        <p v-html="$t('LP.intro.lead_sp')" class="text-pre-wrap"></p>
      </v-container>


      <v-container v-if="!isMobileDevice()" class="mx-auto text-body-1 font-weight-bold text-center text-block mt-8"
        style="line-height:1.8;">
        <p v-html="$t('LP.intro.lead_pc')" class="text-pre-wrap"></p>
      </v-container>

    </v-container>


    <!-- Twitter Embed 
    <v-container id="info" class="text-center py-15">
      <h2 class="h2 font-weight mb-5">
        INFORMATION
      </h2>
      <TweetEmbed />
    </v-container>-->

    <!-- About -->
    <v-container id="about" class="text-center py-15">
      <h2 class="h2 font-weight mb-5">
        ABOUT
      </h2>
      <v-container v-if="isMobileDevice()" class="mx-auto text-body-2 font-weight-bold text-center text-block mt-8"
        style="line-height:1.8;">
        <p v-html="$t('LP.about.caption_sp')" class="text-pre-wrap"></p>
      </v-container>


      <v-container v-if="!isMobileDevice()" class="mx-auto text-body-2 font-weight-bold text-center text-block mt-8"
        style="line-height:1.8;">
        <p v-html="$t('LP.about.caption_pc')" class="text-pre-wrap"></p>
      </v-container>
    </v-container>


    <!-- Contents -->
    <v-container id="contents" class="py-15">
      <v-container class="text-center mb-5">
        <h2 class="h2 font-weight">
          CONTENTS
        </h2>
      </v-container>
      <!-- コンテンツ読み込み -->
      <ContentsNormal />
    </v-container>

    <!-- Route Map -->
    <v-container id="route" class="text-center py-15">
      <h2 class="h2 font-weight mb-5">
        ROUTE MAP
      </h2>
      <v-container v-if="isMobileDevice()" class="mx-auto text-body-1 font-weight-bold text-center text-block mt-8"
        style="line-height:1.8;">
        <p v-html="$t('LP.route.caption_sp')" class="text-pre-wrap"></p>
      </v-container>

      <v-container v-if="!isMobileDevice()" class="mx-auto text-body-1 font-weight-bold text-center text-block mt-8"
        style="line-height:1.8;">
        <p v-html="$t('LP.route.caption_pc')" class="text-pre-wrap"></p>
      </v-container>

      <v-container>
        <v-img :src="$t('LP.route.map')"></v-img>
      </v-container>
    </v-container>

    <!-- チケットテーブル -->
    <v-container id="tickets" class="text-center py-15" fluid>
      <h2 class="h2 font-weight mb-5">
        TICKETS
      </h2>
      <v-container class="mx-auto text-body-1 font-weight-bold text-center text-block mt-8"
        style="line-height:1.8;">
        <p v-html="$t('LP.tickets.tickets_1')" class="text-pre-wrap"></p>
      </v-container>

        <!-- リンクボタン -->
        <v-container>
            <v-layout v-bind="binding" class="pt-10">
                <v-flex xs12 sm4 offset-sm-4 text-center>
                    <v-btn rounded light :href="ticket_url" width="90%" height="50" target="_blank">
                        <span class="text-sm-body-2 text-md-body-1">
                            {{$t("LP.tickets.button")}}
                        </span>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </v-container>    


    <!-- OUTLINE -->
    <out-line-access />


    <!-- CREDIT -->
    <credit />



    <v-container class="text-center">
      <a v-smooth-scroll href="#app" class="mx-auto text-h6 font-weight-light white--text text-decoration-none">
        <span class="allow-top">＞</span>TOP<span class="allow-top">＞</span>
      </a>
    </v-container>




    <v-footer padless class="black">
      <!-- SNSリンク -->
      <v-container id="links" class="text-center py-10">
        <v-responsive class="mx-auto" max-width="400">
          <v-row>
            <v-col v-for="({icon, url}, i) in links" :key="i" align="center" justify="center">
              <a :href="url" target="_blank">
                <v-img width="36" :src="icon" style="filter:brightness(10);">
                </v-img>
              </a>
            </v-col>
          </v-row>
        </v-responsive>
      </v-container>
      <v-container class="text-center">
        <span class="white--text">&copy; {{ new Date().getFullYear() }} NAKED, inc.</span>
      </v-container>
    </v-footer>



  </v-main>
</template>



<script>
  import isMobile from "ismobilejs";
  //import ContentsSlider from './Contents_slider';
  import ContentsNormal from './Contents_normal.vue';
  //import TweetEmbed from './TweetEmbed';
  import DialogCovid19 from './DialogCovid19';
  //import TicketTable from './TicketTable';
  //import NakedApp from './NAKED-App.vue';
  //import Artist from './Artist';
  import OutLineAccess from './OutLineAccess.vue';
  import Credit from './Credit.vue';

  export default {

    name: 'NakedLP',
    components: {
      ContentsNormal,
      //ContentsSlider,
      //TweetEmbed,
      DialogCovid19,
      //TicketTable,
      //NakedApp,
      //Artist,
      OutLineAccess,
      Credit,
    },


    computed: {
      binding() {
        const binding = {}

        if (this.$vuetify.breakpoint.xsOnly) binding.column = true

        return binding
      },
    },

    methods: {
      changeLocale() {
        this.$emit('change-locale');
      },
    },



    data: () => ({

      // bg素材
      dots: './Images/bg/pattern1.png',
      lines: './Images/bg/pattern2.png',

      ticket_url: 'https://peatix.com/group/11588558/events',

      // 各種SNSのリンク
      //
      // icon => アイコン
      // url => リンク先URL
      links: [{
          icon: './Images/sns/icon_facebook.svg',
          url: 'https://www.facebook.com/NAKEDINC.official/'
        },
        {
          icon: './Images/sns/icon_twitter.svg',
          url: 'https://twitter.com/naked_staff'
        },
        {
          icon: './Images/sns/icon_line.svg',
          url: 'https://page.line.me/nakedinc'
        },
        {
          icon: './Images/sns/icon_instagram.svg',
          url: 'https://www.instagram.com/naked_inc/'
        },
        {
          icon: './Images/sns/icon_youtube.svg',
          url: 'https://www.youtube.com/c/NAKEDINC'
        },
      ],

      // いったん以下は使わない
      //windowWidth: window.innerWidth+'px',

      // PCとモバイルを切り替えるためのもの、消さないように
      isMobile,

      isMobileDevice: function () {
        if (isMobile().any) {
          return true;
        }
        return false;
      },

      // デバッグモード判定
      isDebug: false
    }),
  }
</script>


<style lang="scss">
  html {

    /* ゴシック体 */
    #app {
      z-index: 0;
      overflow-x: hidden;

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      td,
      dd,
      a,
      span,
      div {
        font-family: 'Roboto', 'STIX Two Text''Helvetica Neue', 'Helvetica', 'Noto Sans JP', 'Noto Serif JP'"Hiragino Sans", "Hiragino Kaku Gothic ProN", "Arial", 'Meiryo', sans-serif !important;
      }

    }

    /* 明朝体 */
    /* 
    #app {

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      td,
      dd,
      a,
      span,
      div {
        font-family: 'STIX Two Text', 'Noto Serif JP', "Arial", 'Meiryo', serif !important;
      }

    } */
  }


  .text-primary {
    color: #00d1d5 !important;
  }

  .border-white {
    border: 2px solid #fff !important;
  }

  .br-sm {
    @media screen and (min-width:735px) {
      display: none;
    }
  }

  .text-indent--05 {
    text-indent: -.5em;
  }

  @mixin text-block {
    max-width: 800px;
  }

  .text-block {
    @include text-block;
  }

  /* bgColor */
  .bgSub {
    background-color: #f2f2f2;
  }

  .bgWht {
    background-color: #ffffff;
    color: #121212;
  }

  .allow-top {
    display: inline-block;
    font-size: 1em;
    padding: .5em 0 .5em 0;
    transform-origin: center;
    transform: rotate(-90deg);
  }

  .data-list {
    padding-left: 0;

    li {
      list-style: none;
    }
  }


  #tickets {
    background:rgba(0,0,0,.3);
  }

.bg-abs {
    position: absolute;
    z-index: -1;
}



.bg-dots-01 {
    top: -1%;
    left: -32%;
    width: 80%;

    @media screen and (min-width: 600px) {
        top: 1%;
        left: -20%;
        width: 60%;
    }

    @media screen and (min-width: 960px) {
        top: 1%;
        left: -18%;
        width: 50%;
    }
    @media screen and (min-width: 1440px) {
        top: 0;
        left: -16%;
        width: 36%;
    }
}

.bg-dots-02 {
    top: 30%;
    right: -15%;
    width: 80%;

    @media screen and (min-width: 600px) {
        top: 32%;
        right: -15%;
        width: 60%;
    }

    @media screen and (min-width: 960px) {
        top: 34%;
        right: -15%;
        width: 50%;
    }
    @media screen and (min-width: 1440px) {
        top: 36%;
        right: -15%;
        width: 36%;
    }
}

.bg-dots-03 {
    top: 50%;
    left: -32%;
    width: 80%;

    @media screen and (min-width: 600px) {
        top: 52%;
        left: -20%;
        width: 60%;
    }

    @media screen and (min-width: 960px) {
        top: 54%;
        left: -18%;
        width: 50%;
    }
    @media screen and (min-width: 1440px) {
        top: 56%;
        left: -16%;
        width: 36%;
    }
}

.bg-dots-04 {
    top: 65%;
    right: -32%;
    width: 80%;

    @media screen and (min-width: 600px) {
        top: 68%;
        right: -20%;
        width: 60%;
    }

    @media screen and (min-width: 960px) {
        top: 70%;
        right: -18%;
        width: 50%;
    }
    @media screen and (min-width: 1440px) {
        top: 72%;
        right: -16%;
        width: 36%;
    }
}

.bg-dots-05 {
    top: 80%;
    left: -32%;
    width: 80%;

    @media screen and (min-width: 600px) {
        top: 82%;
        left: -20%;
        width: 60%;
    }

    @media screen and (min-width: 960px) {
        top: 84%;
        left: -18%;
        width: 50%;
    }
    @media screen and (min-width: 1440px) {
        top: 80%;
        left: -16%;
        width: 36%;
    }
}

.bg-lines-01 {
    top: 5%;
    right: -15%;
    width: 70%;

    @media screen and (min-width: 600px) {
    top: 5%;
    right: -18%;
    width: 60%;
    }

    @media screen and (min-width: 960px) {
    top: 7%;
    right: -12%;
    width: 50%;
    }
    @media screen and (min-width: 1440px) {
    top: 5%;
    right: -10%;
    width: 36%;
    }
}

.bg-lines-02 {
    top: 35%;
    left: -15%;
    width: 70%;

    @media screen and (min-width: 600px) {
    top: 38%;
    left: -18%;
    width: 60%;
    }

    @media screen and (min-width: 960px) {
    top: 40%;
    left: -12%;
    width: 50%;
    }
    @media screen and (min-width: 1440px) {
    top: 42%;
    left: -10%;
    width: 36%;
    }
}


.bg-lines-03 {
    top: 50%;
    right: -15%;
    width: 70%;

    @media screen and (min-width: 600px) {
    top: 52%;
    right: -18%;
    width: 60%;
    }

    @media screen and (min-width: 960px) {
    top: 56%;
    right: -12%;
    width: 50%;
    }
    @media screen and (min-width: 1440px) {
    top: 58%;
    right: -10%;
    width: 36%;
    }
}

.bg-lines-04 {
    top: 67%;
    left: -15%;
    width: 70%;

    @media screen and (min-width: 600px) {
    top: 70%;
    left: -18%;
    width: 60%;
    }

    @media screen and (min-width: 960px) {
    top: 73%;
    left: -12%;
    width: 50%;
    }
    @media screen and (min-width: 1440px) {
    top: 77%;
    left: -10%;
    width: 36%;
    }
}

.icon {
    &.arrow {
        position: relative;
        display: inline-block;
        padding: 0 0 0 16px;
        color: #000;
        vertical-align: middle;
        text-decoration: none;
        font-size: 15px;

        &:before{
            position: absolute;
            content: '';
            margin: auto;
            vertical-align: middle;
            top: 0;
            left: 0;
            width: 10px;
            height: 10px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            transform: rotate(45deg) translateY(-70%);
            transform-origin: center;
        }

    }
}
</style>


